var changeRequirement = function changeRequirement(element, set) {
  var group = element.get('GroupName');
  var name = element.get('Name');

  var changePOBoxRequirement = function changePOBoxRequirement(input) {
    return set('addressPOBox', !Boolean(input));
  };

  var changePOBoxRequirementCoApp = function changePOBoxRequirementCoApp(input) {
    return set('coApplicantAddressPOBox', !Boolean(input));
  }; // const changeTradeInRequirement = input => {
  //   return set('tradeIn', Boolean(Number(input)));
  // };


  var changeAddressYearsRequirement = function changeAddressYearsRequirement(input, residenceYears) {
    var bool = Number(input) >= residenceYears ? false : true;
    return set('yearsAtAddress', bool);
  };

  var changeEmployedYearsRequirement = function changeEmployedYearsRequirement(input, residenceYears, employmentYears) {
    var bool = Number(input) >= employmentYears ? false : true;
    return set('yearsAtEmployment', bool);
  };

  var changeAddressYearsRequirementCoApp = function changeAddressYearsRequirementCoApp(input, residenceYears) {
    var bool = Number(input) >= residenceYears ? false : true;
    return set('coApplicantYearsAtAddress', bool);
  };

  var changeEmployedYearsRequirementCoApp = function changeEmployedYearsRequirementCoApp(input, residenceYears, employmentYears) {
    var bool = Number(input) >= employmentYears ? false : true;
    return set('coApplicantYearsAtEmployment', bool);
  };

  if (group === 'Applicant') {
    if (name === 'Address POBox') {
      return changePOBoxRequirement;
    }

    if (name === 'Address Years') {
      return changeAddressYearsRequirement;
    }

    if (name === 'Employer Years') {
      return changeEmployedYearsRequirement;
    }
  }

  if (group === 'CoApplicant') {
    if (name === 'Address POBox') {
      return changePOBoxRequirementCoApp;
    }

    if (name === 'Address Years') {
      return changeAddressYearsRequirementCoApp;
    }

    if (name === 'Employer Years') {
      return changeEmployedYearsRequirementCoApp;
    }
  }

  return function () {
    return null;
  };
};

export default changeRequirement;